export const LDivider = ({ title, isFat }: LDividerProps): JSX.Element => {
    return (
        <>
            {title && (
                <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center">
                    <div className="is-size-5 has-text-ldark-gray">{title}</div>
                </div>
            )}
            {isFat ? <div className="fatDivider" /> : <div className="divider" />}
        </>
    );
};

export interface LDividerProps {
    title?: string;
    isFat?: boolean;
}
